import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import { getUserInfo, checkLogin } from '@/store/authService';
import LayoutView from '@/views/LayoutView.vue';

const routes = [
  {
    path: "/",
    component: LayoutView,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "home" */ "@/pages/home/HomePage.vue"),
      },
      {
        path: 'students',
        component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/students/StudentPage.vue"),
        meta: {
          title: "Alunos"
        },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "students" */ "@/pages/educational/students/StudentListPage.vue"),
            meta: {
              title: "Alunos"
            },
          },
          {
            path: 'add',
            component: () => import(/* webpackChunkName: "students" */ "@/pages/educational/students/StudentFormPage.vue"),
            meta: {
              title: "Novo Aluno",
            },
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/students/StudentFormPage.vue"),
            meta: {
              title: "Editar Aluno",
            },
          },
        ]
      },
      {
        path: 'courses',
        component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/courses/CoursePage.vue"),
        meta: {
          title: "Cursos"
        },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/courses/CourseListPage.vue"),
            meta: {
              title: "Cursos"
            },
          },
          {
            path: 'add',
            component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/courses/CourseFormPage.vue"),
            meta: {
              title: "Novo Curso",
            },
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "courses" */ "@/pages/educational/courses/CourseFormPage.vue"),
            meta: {
              title: "Editar Curso",
            },
          },
        ]
      },
      {
        path: 'users',
        component: () => import(/* webpackChunkName: "users" */ "@/pages/admin/users/UserPage.vue"),
        meta: {
          title: "Usuários Administrativos"
        },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "users" */ "@/pages/admin/users/UserListPage.vue"),
            meta: {
              title: "Usuários Administrativos"
            },
          },
          {
            path: 'add',
            component: () => import(/* webpackChunkName: "users" */ "@/pages/admin/users/UserFormPage.vue"),
            meta: {
              title: "Novo Usuário",
            },
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "users" */ "@/pages/admin/users/UserFormPage.vue"),
            meta: {
              title: "Editar Usuário",
            },
          },
        ],
      },
      {
        path: 'login',
        component: () => import(/* webpackChunkName: "login" */ "@/pages/login/LoginPage.vue"),
        meta: {
          title: "Login",
          header: {
            isLogged: false,
          },
        },
      },
      {
        path: 'logout',
        component: () => import(/* webpackChunkName: "login" */ "@/pages/login/LogoutPage.vue"),
        meta: {
          title: "Logout",
          // header: {
          //   isLogged: false,
          // },
        },
      },
      {
        path: 'videos-list',
        component: () => import(/* webpackChunkName: "videos" */ "@/pages/video/ListVideoPage.vue"),
        meta: {
          title: "Lista de Vídeos",
        },
      },
      {
        path: 'videos-upload',
        component: () => import(/* webpackChunkName: "videos" */ "@/pages/video/UploadVideoPage.vue"),
        meta: {
          title: "Upload de Vídeos",
        },
      },
      {
        path: 'videos-edit',
        component: () => import(/* webpackChunkName: "videos" */ "@/pages/video/EditVideoPage.vue"),
        meta: {
          title: "Edição de Vídeo",
        },
      },
      {
        path: 'videos-watch',
        component: () => import(/* webpackChunkName: "videos" */ "@/pages/video/WatchVideoPage.vue"),
        meta: {
          title: "Player Vídeo",
        },
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import(/* webpackChunkName: "404" */ "@/views/NotFoundView.vue"),
        meta: {
          title: "Página Não Encontrada",
        },
      },
    ],
  },
];

const isElectron = !!(window.electronAPI && window.electronAPI.isElectron);

const router = createRouter({
  history: isElectron ? createWebHashHistory() : createWebHistory(),
  // history: createWebHistory('/uFormPanel/'),
  routes,
});

let isFirstPageLoad = true;

router.beforeEach(async (to, from, next) => {
  const requireLogin = to.meta?.header?.isLogged !== false;

  // Detecta se é o primeiro carregamento da página
  if (isFirstPageLoad) {
    // console.log(`Primeiro acesso detectado na rota: ${to.path}`);
    isFirstPageLoad = false; // Marca que o primeiro carregamento já ocorreu
    // Realize ações específicas para o primeiro acesso, se necessário
    await checkLogin();
  }

  if(requireLogin && !getUserInfo()?.isLoggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }
  else if (!requireLogin && getUserInfo()?.isLoggedIn) {
    return next({ path: '/' });
  }
  document.title = to.meta?.title ? `${to.meta.title} | UformPanel` : "UformPanel";
  next();
});

export default router;
